import React from 'react';
import { useLanguage } from '@/App';
import { ArrowRight, Users, Building2 } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { getRoute } from '../utils/routes';
import { ScrollReveal } from '@/components/ScrollReveal';

const CallToAction = () => {
  const { language } = useLanguage();
  const navigate = useNavigate();

  const content = {
    tr: {
      title: 'İletişime Geçin',
      subtitle: 'Projenizi konuşalım.',
      influencerBox: 'Influencerlar İçin',
      influencerCta: 'Kayıt Olun',
      brandBox: 'Markalar İçin',
      brandCta: 'Bizimle Çalışın'
    },
    en: {
      title: 'Get in Touch',
      subtitle: 'Let\'s talk about your project.',
      influencerBox: 'For Influencers',
      influencerCta: 'Sign Up',
      brandBox: 'For Brands',
      brandCta: 'Work With Us'
    }
  };

  const t = content[language];

  const goToContactForm = () => {
    const aboutRoute = getRoute('about', language);
    navigate(aboutRoute);
    // Wait for navigation then scroll to contact section
    setTimeout(() => {
      const element = document.getElementById('contact');
      if (element) {
        const offsetTop = element.offsetTop - 150;
        window.scrollTo({
          top: offsetTop,
          behavior: 'smooth'
        });
      }
    }, 100);
  };

  return (
    <section className="py-8 md:py-12 bg-black bg-opacity-75">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Title */}
        <ScrollReveal>
          <h2 className="text-2xl md:text-4xl font-bold text-[#FFDD59] text-center mb-2">
            {t.title}
          </h2>
          <p className="text-gray-300 text-center text-sm md:text-lg mb-6 md:mb-8 px-2">
            {t.subtitle}
          </p>
        </ScrollReveal>
        
        {/* Single Brand Box - Centered */}
        <div className="max-w-md mx-auto">
          <ScrollReveal delay={100}>
            {/* Brand Box */}
            <div className="bg-gray-900 border border-gray-700 text-white rounded-xl p-6 md:p-8 hover:border-[#FFDD59] transition-colors duration-300 text-center card-hover-glow">
              <Building2 className="mx-auto mb-3 md:mb-4" size={48} color="#FFDD59" />
              <h3 className="text-lg md:text-xl font-bold text-[#FFDD59] mb-2">{t.brandBox}</h3>
              <button 
                onClick={goToContactForm}
                className="w-full mt-3 md:mt-4 py-2.5 md:py-3 bg-[#FFDD59] text-black font-bold rounded-lg hover:bg-yellow-400 transition flex items-center justify-center gap-2 text-sm md:text-base"
              >
                {t.brandCta}
                <ArrowRight size={18} />
              </button>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
